import { ITimestampResponse } from '@/types/common';
import { Moment } from 'moment';

export enum TypeSurveyHealth {
  EAR_HEALTH = 'EAR_HEALTH', // 耳の健康のチェック
  EYE_HEALTH = 'EYE_HEALTH', // 目の健康のチェック
  SWALLOWING_ABILITY = 'SWALLOWING_ABILITY', // 飲み込み力のチェック
  ORAL_HEALTH = 'ORAL_HEALTH', // お口の健康のチェック
  MEAL_BALANCE = 'MEAL_BALANCE', // 食事バランスのチェック
  HEALTH_PERCEPTION = 'HEALTH_PERCEPTION', // 健康感のチェック
}

export enum PassOperator {
  GREATER_OR_EQUAL = 'GREATER_OR_EQUAL', // '>=',
  LESS_OR_EQUAL = 'LESS_OR_EQUAL', // '<=',
}

export const generateSurveyHealthTypeText = (value: TypeSurveyHealth) => {
  switch (value) {
    case TypeSurveyHealth.EAR_HEALTH:
      return '耳の健康のチェック';
    case TypeSurveyHealth.EYE_HEALTH:
      return '目の健康のチェック';
    case TypeSurveyHealth.SWALLOWING_ABILITY:
      return '飲み込み力のチェック';
    case TypeSurveyHealth.ORAL_HEALTH:
      return 'お口の健康のチェック';
    case TypeSurveyHealth.MEAL_BALANCE:
      return '食事バランスのチェック';
    case TypeSurveyHealth.HEALTH_PERCEPTION:
      return '健康感のチェック';
    default:
      return '耳の健康のチェック';
  }
};

export interface ISurveyHealth extends ITimestampResponse {
  id: number;
  name: string;
  title: string;
  description: string;
  message: string;
  sortOrder: number;
  status: number;
  type: TypeSurveyHealth;
  completePoint?: number;
  passOperator?: PassOperator | null;
}

export interface IGetListSurveyHeathResponse extends ISurveyHealth {}

export interface IGetDetailSurveyHealthResponse extends ISurveyHealth {}

export interface ICreateSurveyHealthResponse extends ISurveyHealth {}

export interface IUpdateSurveyHealthResponse extends ISurveyHealth {}
